import { ApiService as api } from "../Services/APIService";
import { TemplateService } from "../Services/TemplateService";

const cardTemplate = 'TodayCard';

export class TodayModule {
    static async Init() {
        DEBUG && console.info('*--> Today Module Init');

        var elements = document.querySelectorAll('[data-component="today"]');

        elements.forEach(element => {

            var congregationId = element.getAttribute('data-congregationId');
            var campus = element.getAttribute('data-campus');

            DEBUG && console.info('**************************************************');
            DEBUG && console.info(`Element ID:              ${element.id}`);
            DEBUG && console.info(`Congregation ID:         ${congregationId}`);
            DEBUG && console.info(`Campus:                  ${campus}`);
            DEBUG && console.info('**************************************************');

            this.InitCard(element, congregationId, campus);
        });
    }

    static async InitCard(element, congregationId, campus) {
        var data = await this.GetTodaySermon(congregationId, campus);

        if (data.Sermon) { 

            var content = await TemplateService.GetRenderedTemplate(cardTemplate, data);

            element.innerHTML = content;
        }
    }

    static async GetTodaySermon(congregationId, campus) {
        var data = await api.getData(`Sermon/GetTodaySermon?congregationId=${congregationId}&campus=${campus}`);
        DEBUG && console.info(data);
        return data;
    }
}